import * as React from 'react';
export var useMergedRef = function (ref) {
    var innerRef = React.useRef(null);
    return (ref ? ref : innerRef);
};
//# sourceMappingURL=useMergedRef.js.map